import { Plus } from "@phosphor-icons/react";
import { useTranslation } from "react-i18next";
import { useActionButton } from "~/actions/adapters/button";
import { newDocument } from "~/actions/definitions/documents";
import { useDocuments } from "~/api/queries";
import { DocumentList } from "~/features/documents/DocumentList";
import { Button } from "~/foundation/components/Button";
import { Text } from "~/foundation/components/Text";
import { useDocumentTitle } from "~/foundation/hooks/useDocumentTitle";

export function DocumentsScene() {
  const { t } = useTranslation();
  const { data: documents, isLoading } = useDocuments({ status: "published" });
  const newDocumentButton = useActionButton(newDocument);
  useDocumentTitle(t("Documents"));

  return (
    <div className="mx-auto flex w-full max-w-3xl flex-col gap-4 p-6">
      <div className="flex items-center justify-between gap-4">
        <Text as="h1" variant="h2">
          {t("Documents")}
        </Text>
        {newDocumentButton.visible ? (
          <Button variant="primary" icon={Plus} onClick={newDocumentButton.onClick}>
            {newDocumentButton.title}
          </Button>
        ) : null}
      </div>

      <DocumentList
        documents={documents}
        isLoading={isLoading}
        emptyTitle={t("No documents")}
        emptyMessage={t("Documents you create in this workspace will show up here.")}
      />
    </div>
  );
}
